import { render } from "./Box.vue?vue&type=template&id=5863e350&scoped=true"
import script from "./Box.vue?vue&type=script&lang=js"
export * from "./Box.vue?vue&type=script&lang=js"

import "./Box.vue?vue&type=style&index=0&id=5863e350&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5863e350"

export default script